module.exports = __webpack_public_path__ + "static/media/参数2.9b0f3ef9.jpg";